<template>
  <b-form-group class="mb-3">
    <label v-if="label" class="d-block">{{ label }}</label>
    <b-form-radio-group
      buttons
      button-variant="outline-primary"
      name="type"
      v-model="type"
      :options="types"
      :size="size"
      class="mr-2"
      @input="$emit('input', type)"
      :disabled="disabled"
    />
  </b-form-group>
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
        default: 'email'
      },
      size: {
        type: String,
        default: 'md',
      },
      label: String,
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        trans: trans,
        type: this.value,
        types: [{
          value: 'email',
          text: trans('email'),
        },{
          value: 'both',
          text: trans('both_sms_email'),
        }, {
          value: 'sms',
          text: trans('sms'),
        }],
      }
    },
    watch: {
      value(value) {
        this.type = value
      } 
    },
    mounted() {
      window.typeComponent = this
    }
  }
</script>
